export enum CalculationType {
  Fixed = -10,
  None = 0,
  CalculationBasePrice = 10,
  CalculationAlternativePrice = 11,
  CalculationCount = 12
}
